import TextField from '@mui/material/TextField';
import React from 'react';

const TimeInputWithBlur = ({ label, value, onChange, onBlur }) => {
    const formatTime = (value) => {
        const cleaned = value.replace(/\D/g, '');
        const hour = cleaned.slice(0, 2);
        const minute = cleaned.slice(2, 4);
        return `${hour}:${minute}`;
    };

    return (
        <TextField
            label={label}
            fullWidth
            value={formatTime(value)}
            onChange={onChange}
            onBlur={onBlur}
            inputProps={{
                maxLength: 5, // Limita a entrada a 5 caracteres (hh:mm)
                inputMode: "numeric"
            }}
        />
    );
};

export default TimeInputWithBlur;